module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticeHandsHips2-13a429b2c8f7b2f101a13dd077b67c2c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticeHandsHips2.png
// module id = 2433
// module chunks = 2